import { useQuestions } from '../questions/QuestionsContext';
import { SectionFrame } from '../components/SectionFrame';
import { formatDisplayDate } from '../format';
import type { SectionProps } from './sectionProps';

/** The employee's view of work locations is history only; assignments are employer-managed and payroll-relevant. */
export function WorkLocationSection({ setup, next, back }: SectionProps) {
  const rows = setup.workLocations;
  const questions = useQuestions();
  return (
    <SectionFrame title="Work Location" onSubmit={next} onBack={back}>
      <p className="eo-note">Your employer assigns and maintains your work locations. This is a read-only history.</p>
      {questions && (
        <p className="eo-note">
          <button type="button" className="eo-ask" onClick={() => questions.ask('workLocation')}>Ask about this</button>
        </p>
      )}
      <div className="eo-table-wrap">
        <table className="eo-table">
          <caption className="eo-sr-only">Work location history</caption>
          <thead>
            <tr>
              <th scope="col">Type</th>
              <th scope="col">From</th>
              <th scope="col">To</th>
              <th scope="col">Effective Date</th>
              <th scope="col">Changed By</th>
              <th scope="col">Date Changed</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={`${r.type}-${r.effectiveDate}-${i}`}>
                <td>{r.type}</td>
                <td>{r.from ?? '—'}</td>
                <td>{r.to}</td>
                <td>{formatDisplayDate(r.effectiveDate)}</td>
                <td>{r.changedBy ?? '—'}</td>
                <td>{formatDisplayDate(r.dateChanged)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows.length === 0 && (
          <div className="eo-empty" data-testid="work-location-empty">
            <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" focusable="false">
              <path fill="#1577bd" d="M3 6a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6Z" />
            </svg>
            <p className="eo-empty__title">No Data Available</p>
            <p className="eo-empty__text">No work location has been assigned to you yet. Your employer will add it, and you do not need to enter anything here.</p>
          </div>
        )}
      </div>
    </SectionFrame>
  );
}
